import { Outlet } from "react-router";
import TopMenu from "./TopMenu";
import SideMenu from "./SideMenu";
import { ScrollView } from "devextreme-react";
import { isMobile } from "../helper/helper";
import withAuth from "@/hoc/withAuth";
import AppVersion from "./AppVersion";
import { IS_PRODUCTION } from "@/constants/constants";

function Container() {
  return (
    <div>
      <TopMenu inContext />
      {!IS_PRODUCTION ? <AppVersion /> : null}
      <div className="website-wrapper">
        <SideMenu />
        <main className={`main_container`}>
          <ScrollView
            height={isMobile.any() ? "calc(100vh - 11.875rem)" : "calc(100vh - 85px)"}
          >
            <div className="mt-6 screen:px-8 screen:pb-8">
              <Outlet />
            </div>
          </ScrollView>
        </main>
      </div>
    </div>
  );
}

export default withAuth(Container);
